import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { IconButton, InputAdornment, Input, InputLabel, Button, FormHelperText, Grid, Paper } 
  from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import EmailIcon from '@material-ui/icons/Email';
import { FormContainer, InputControl, Container } from './styles';
import {LogoVertical} from '../Logo';
import { auth } from '../../service/auth.service';
import { useAuth } from '../../hooks/useAuth';
import { LoadingButton } from '../Loading';


const LoginForm = () => {
  const {updateUser} = useAuth();
  const history = useHistory();
  const [values, setValues] = useState({
    login: '',
    password: '',
    showPassword: false,
    redirect: false,
    errStatus: null,
    errMsg: '',
  });
  const [getLoadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    if (values.errStatus === 500) toast.error(values.errMsg);
    if (values.errStatus === 404) toast.warning(values.errMsg);
    setValues({ ...values, errStatus: '' })
  }, [values.errStatus]);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handlerLogin = async (e) => {
    e.preventDefault();
    if (getLoadingButton) return;

    setLoadingButton(true);
    const { success, msg, status } = await auth(values.login, values.password);
    if (success) {
      updateUser();
      history.push('/');
    }
    else {
      setLoadingButton(false);
      setValues({ ...values, errStatus: status, errMsg: msg });
    }
  };

  return (
    <Container>
      {values.redirect && <Redirect to="/" />}
      <Grid container spacing={2}>
      <Grid container item spacing={2} style={{ justifyContent: 'center', alignItems: 'flex-end' }}>

        <Grid item xs={3} sm={2}>
        <div className="btnLogin">
          <a href="https://www.youtube.com/watch?v=-zzm89S9Lvg" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src="https://img.youtube.com/vi/-zzm89S9Lvg/0.jpg" 
              alt=""/>
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/75/YouTube_social_white_squircle_%282017%29.svg"
                alt="Play" 
                title='Assista o vídeo com instruções para login'/>
          </a>
        </div>
        </Grid>

        <Grid item xs={10} sm={8}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <LogoVertical />
          <FormContainer
            elevation={1}
            className='sombra'
          >
            <form onSubmit={handlerLogin}>
              <InputControl fullWidth error={!!values.errMsg}>
                <InputLabel htmlFor="email">Login</InputLabel>
                <Input
                  id="email"
                  required
                  value={values.login}
                  onChange={(e) => setValues({ ...values, login: e.target.value })}
                  endAdornment={
                    <InputAdornment position="end">
                      <EmailIcon style={{ color: '#707070', marginRight: 12 }} />
                    </InputAdornment>
                  }
                />
                {values.errMsg && values.login === '' && (
                  <FormHelperText id="component-error-text">Campo Obrigatório</FormHelperText>
                )}
              </InputControl>
              <InputControl fullWidth error={!!values.errMsg}>
                <InputLabel htmlFor="password">Password</InputLabel>
                <Input
                  id="password"
                  type={values.showPassword ? 'text' : 'password'}
                  value={values.password}
                  onChange={(e) => setValues({ ...values, password: e.target.value })}
                  required
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                        {values.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {values.errMsg && values.password === '' && <FormHelperText>Campo Obrigatório</FormHelperText>}
                {values.errMsg && <FormHelperText>{values.errMsg}</FormHelperText>}
              </InputControl>
              <div className="footer">
                <Button className="entrar" variant="contained" type="submit">
                  {getLoadingButton ? 
                    (<LoadingButton />) : 
                    (<></>) 
                  }
                  Entrar
                </Button>
                <Link to="/register" style={{ fontSize: '11px', textDecoration: 'none' }}>
                  Registro de Usuário
                </Link>
              </div>
            </form>
          </FormContainer>
        </div>
        </Grid>

        <Grid item xs={3} sm={2}>
        <div className="btnLogin">
          <a href="https://youtu.be/LzgrrjIpkJE" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img src="https://img.youtube.com/vi/LzgrrjIpkJE/0.jpg" 
              alt=""/>
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/75/YouTube_social_white_squircle_%282017%29.svg"
                alt="Play" 
                title='Instruções para Registro de Usuário'/>
          </a>
        </div>
        </Grid>

        </Grid>
      </Grid>
    </Container>
  );
};

export default LoginForm;
